import React from "react";
import { ToastContainer } from "react-toastify";
import { Route, Switch, BrowserRouter } from "react-router-dom";
import LoggedIn from "./Containers/LoggedIn";
import LoggedOut from "./Containers/LoggedOut";
import { isUser } from "./utils/helpers";
import { automatedServerRoute } from "./utils/Constant";
import SendReportsAuto from "./Containers/Components/SendReports/Components/SendReportsAuto";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

class App extends React.Component {
  render() {
    const { location } = this.props;

    // Check if server is opening the page, if so render minimal content
    if (location.pathname === automatedServerRoute) {
      return (
        <div className="App__Server">
          <ToastContainer
            autoClose={3500}
            newestOnTop
            hideProgressBar={false}
            theme="colored"
            closeButton
            closeOnClick={false}
            pauseOnFocusLoss={false}
            draggable={false}
          />
          <BrowserRouter>
            <Switch>
              <Route path={automatedServerRoute}>
                <SendReportsAuto server />
              </Route>
            </Switch>
          </BrowserRouter>
        </div>
      );
    }
    return (
      <div>
        <ToastContainer
          autoClose={3500}
          newestOnTop
          hideProgressBar={false}
          theme="colored"
          closeButton
          closeOnClick={false}
          pauseOnFocusLoss={false}
          draggable={false}
        />
        {isUser() ? (
          <Route path="/" component={LoggedIn} />
        ) : (
          <Route path="/" component={LoggedOut} />
        )}
      </div>
    );
  }
}

export default App;
